import React from 'react';

export default function Pencil() {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_5770_24651)">
        <ellipse cx="10.1176" cy="10.5" rx="6.11765" ry="6.5" fill="white" />
      </g>
      <path d="M7.28161 12.0853L8.67969 13.4834L12.5442 9.61887L11.1461 8.22079L7.28161 12.0853Z" fill="#404040" />
      <path
        d="M13.4486 8.06241L12.7059 7.31969C12.5249 7.13871 12.2187 7.15149 12.022 7.34825L11.3242 8.04603L12.7223 9.44409L13.4201 8.74633C13.6168 8.54957 13.6296 8.24337 13.4486 8.06241Z"
        fill="#404040"
      />
      <path d="M7.15445 12.3052L6.66016 14.1074L8.46218 13.6131L7.15445 12.3052Z" fill="#404040" />
      <defs>
        <filter
          id="filter0_d_5770_24651"
          x="0"
          y="0"
          width="20.2344"
          height="21"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.910345 0 0 0 0 0.675 0 0 0 0.7 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5770_24651" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5770_24651" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
